import { IOverlayOptions } from './overlay-options';
import { isElementInViewport } from '@/shared/utils/ui';
import { isNull } from '@/shared/utils/utils';

export class Overlay {
    id = null
    target: HTMLElement = null
    overlay: HTMLElement = null
    customStyles: string[] = []
    options: IOverlayOptions = {
        text: 'Dumac.Common.Loading',
        backgroundColor: 'rgba(230, 233, 236, 0.6)'
    }

    private transitionEndHandler = null

    constructor(id: string, target: HTMLElement) {
        this.id = id
        this.target = target
        this.transitionEndHandler = this.onTransitionEnd.bind(this)
    }

    show(overlay: HTMLElement) {
        this.overlay = overlay;

        window.requestAnimationFrame(() => {
            if(!isNull(this.overlay)) {
                this.overlay.style.opacity = '1';
            }
        });
    }

    hide() {
        if (!this.overlay) return

        this.overlay.removeEventListener('transitionend', this.transitionEndHandler);

        if (!isElementInViewport(this.overlay)) {
            this.onTransitionEnd()
        }
        else {
            this.overlay.addEventListener('transitionend', this.transitionEndHandler);
            this.overlay.style.opacity = '0';
        }
    }

    private onTransitionEnd() {
        this.customStyles.forEach(p => this.target.style.removeProperty(p))
        this.overlay = null
        $(`#${this.id}`).remove()
    }
}
